<template>
  <div class="gallery__item" @click="handlerClick(item)">
    <img
      v-if="item.img"
      :src="item.img"
      :alt="item.name"
      class="gallery__img"
    >
    <img v-if="icon_status" class="gallery_status_img" :src="icon_status">
    <div v-else class="gallery__placeholder" />
    <el-checkbox
      v-if="isEdit"
      v-model="item.isChecked"
      class="checkbox"
    />
    <span v-if="item.name" class="gallery__label">{{ item.name }}</span>
  </div>
</template>

<script>
import { GetTianMuDevicePlanLibrary } from '@/axios/IDevice.js'
import { Call } from '@/axios/IScene.js'
import { alerterror, alertsuccess } from '@/assets/js/common.js'
// 方案状态
export const PLANSTATUS = {
  AllSuccess: 1, // 全部成功
  Invalid: 99, // 无效
  Overflow: 4, // 满了 && 溢出
  UnConfiged: 93, // 未配置
  Configing: 0, // 配置中
  SomeSuccess: 2, // 部分成功
  Failure: 3, // 失败
}

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '1', // 1.品质光 2.ai图
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      status: 1,
      icon_status: null,
    }
  },

  watch: {
    'item.SceneStatus': {
      handler() {
        this.init()
      },
      immediate: false,
    },
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      try {
        if (this.isHistory) {
          this.status = PLANSTATUS.AllSuccess;

          return;
        };

        const { SceneId, SceneStatus } = this.item
        const icon_unConfig = require('@/assets/img/tianmu/unConfig.png')
        const icon_configIng = require('@/assets/img/tianmu/configIng.png')
        const icon_configFailure = require('@/assets/img/tianmu/configFailure.png')
        const icon_overflow = require('@/assets/img/tianmu/overflow.png')

        const iconMap = {
          [PLANSTATUS.UnConfiged]: icon_unConfig,
          [PLANSTATUS.AllSuccess]: null,
          [PLANSTATUS.Configing]: icon_configIng,
          [PLANSTATUS.Invalid]: icon_configFailure,
          [PLANSTATUS.Overflow]: icon_overflow,
          [PLANSTATUS.SomeSuccess]: icon_configFailure,
          [PLANSTATUS.Failure]: icon_configFailure,
        }

        const status = !SceneId ? PLANSTATUS.UnConfiged : SceneStatus

        this.icon_status = iconMap[status]
        this.status = status
      } catch (error) {
        console.log(error)
      }
    },

    handlerClick(item) {
      // 编辑模式下，不处理场景逻辑，让 checkbox 自然工作
      if (this.isEdit) {
        return
      }

      if (this.status === PLANSTATUS.UnConfiged) {
        this.$emit('createScene', item)
      }

      if (this.status === PLANSTATUS.AllSuccess) {
        this.callScene()
      }

      //场景重试
      if (this.status === PLANSTATUS.Failure) {
        this.$emit('reSyncDeviceConfig', item)
      }


    },

    async callScene() {
      try {
        const res = await Call({
          sceneNo: this.item.SceneId,
        })
        
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          alertsuccess(this, res.StatusCode)
        } else {
          alerterror(this, res.StatusCode)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.gallery__item {
  position: relative;
  width: 180px;
  height: 180px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden; // 触发内部 BFC，并裁剪圆角

  // 内部占位块
  .gallery__placeholder {
    width: 100%;
    height: 100%;
    background-color: #e0e0e0;
  }

  .gallery__img {
    width: 100%;
    height: 100%;
    object-fit: cover; // 确保图片按比例填充固定 px 区域
    display: block;
    cursor: pointer;
  }

  .gallery__label {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 8px 8px; // 渐变背景起始位置
    box-sizing: border-box;
    color: #fff;
    font-size: 12px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
    pointer-events: none; // 防止标签遮挡点击事件
  }

  .gallery_status_img {
    position: absolute;
    width: 34px;
    height: 34px;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    cursor: pointer;
  }

  .checkbox {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>
